module.exports = __webpack_public_path__ + "static/media/ethereum.e48abf6a.png";